import moment from "moment";
import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getAccessToken } from "./utils";

export const UPDATE_FILTER_REFINE_SORT_SMR_KEYWORD = "UPDATE_FILTER_REFINE_SORT_SMR_KEYWORD";
export const UPDATE_CUSTOM_QUERY_SMR_KEYWORD = "UPDATE_CUSTOM_QUERY_SMR_KEYWORD";
export const APPLY_FILTER_SMR_KEYWORD = "APPLY_FILTER_SMR_KEYWORD";
export const FETCH_SMR_KEYWORD_LISTS = "FETCH_SMR_KEYWORD_LISTS";
export const RESET_CURRENT_SMR_KEYWORD_FILTER = "RESET_CURRENT_SMR_KEYWORD_FILTER";
export const RELOAD_PAGE = "RELOAD_PAGE";

export const filterRefineSortUpdateSMRKeyword = (payload) => ({ type: UPDATE_FILTER_REFINE_SORT_SMR_KEYWORD, payload });
export const updateCustomSMRKeyword = (payload) => ({ type: UPDATE_CUSTOM_QUERY_SMR_KEYWORD, payload });
export const applyFilterSMRKeyword = (payload) => ({ type: APPLY_FILTER_SMR_KEYWORD, payload });
export const resetFilterSMRKeyword = () => ({ type: RESET_CURRENT_SMR_KEYWORD_FILTER });
export const reloadConversationPage = () => ({ type: RELOAD_PAGE });

export const SMRKeywordLists = () => {
    let res = axios({
        method: "get",
        url: `${getUrl("smr_keyword")}/list`,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
            cache: false,
        },
    })
        .then((res) => {
            return res.data?.data?.rules || [];
        })
        .catch((err) => {
            return err.response;
        });

    return {
        type: FETCH_SMR_KEYWORD_LISTS,
        payload: res,
    };
};
